import React from "react";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import { red } from "@mui/material/colors";
import ShareIcon from "@mui/icons-material/Share";
import IconButton from "@mui/material/IconButton";
import Commentlogo from "../../../images/comments.png";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import axios from "axios";
import { Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import ReplyPost from "../../Cluster/ReplyPost";
import DeletePost from "../../Cluster/DeletePost";
import LikesCount from "../../Cluster/LikesCount";
import ReactLinkify from "react-linkify";
// import "react-linkify/dist/esm/styles.min.css";
const Cardd = ({
  token,
  post,
  baseUrl,
  forceUpdate,
  commentOpen,
  width,
  handleReply,
  userId,
  navigate,
  setPosts,
  handleClose,
  userName,
  setCommentopen,
  posts,
}) => {
  const userProfileRedirect = async (userID) => {
    navigate(`/AlluserProfile/${userID}`);
    console.log("userdid", userID);
  };
  const redirectToClusterPage = async (clusterName) => {
    console.log("clusterName", clusterName);
    localStorage.setItem("clusterId", clusterName);
    const url = baseUrl + `/api/cluster/getclusterbyname/${clusterName}`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("chala kya", response);
    navigate(`/create-cluster-redirection/${clusterName}`);
    return response;
  };

  return (
    <Card className="mb-3 py-3">
      <CardHeader
        avatar={
          <div
            className="cursor-pointer"
            onClick={() => {
              userProfileRedirect(post?.postedBy?.user);
            }}
          >
            {post?.postedBy?.userPic && post.postedBy.userPic ? (
              <img
                src={post.postedBy.userPic ? post.postedBy.userPic : "Img"}
                alt="posted-user-pick"
                className="rounded-full"
                style={{
                  height: width > 768 ? "56px" : "40px",
                  width: width > 768 ? "56px" : "40px",
                }}
              />
            ) : (
              <Avatar
                sx={{ bgcolor: red[500] }}
                aria-label="recipe"
                className="rounded-full"
                style={{
                  height: width > 768 ? "56px" : "40px",
                  width: width > 768 ? "56px" : "40px",
                }}
              />
            )}
          </div>
        }
        action={
          <>
            {/* <span
          aria-describedby={id}
          variant="contained"
          onClick={moreData}
          style={{ cursor: "pointer" }}
        >
          {post.postedBy.user === userId ? (
            <DeleteIcon />
          ) : null}
        </span> */}
            {post?.postedBy?.user && post.postedBy.user === userId ? (
              <DeletePost
                forceUpdate={forceUpdate}
                baseUrl={baseUrl}
                token={token}
                post={post}
                setPosts={setPosts}
                posts={posts}
                handleClose={handleClose}
              />
            ) : null}

            {/* {post.postedBy.user === userId && (
          <Popover
            id={idEdit}
            open={openpopEdit}
            anchorEl={anchorE2}
            onClose={handleCloseEdit}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <EditPost
              baseUrl={baseUrl}
              posts={posts}
              setPosts={setPosts}
              post={post}
            />
          </Popover>
        )} */}
          </>
        }
        title={
          <Box
            sx={{ display: "flex", gap: "10px" }}
            className="w-full flex items-center gap-5"
          >
            <Typography
              variant="body3"
              // color="text.secondary"
              sx={{
                pr: "10px",
                fontSize: width > 768 ? "17px" : "10px",
              }}
            >
              {<span
                style={{
                  fontSize: width > 768 ? "16px" : "14px",
                  fontWeight: width > 768 ? "700" : "700",
                }}
              >
                {post?.postedBy?.userName && post.postedBy.userName}
              </span> ? (
                <span
                  style={{
                    fontSize: width > 768 ? "16px" : "14px",
                    fontWeight: width > 768 ? "700" : "700",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    userProfileRedirect(post.postedBy.user);
                  }}
                  className="hover:text-blue-700 hover:underline"
                >
                  {post?.postedBy?.userName && post.postedBy.userName}
                </span>
              ) : (
                <a href={"/userlogin"}>{userName}</a>
              )}
            </Typography>
            <Typography
              variant="body4"
              color="text.secondary"
              sx={{ fontSize: width > 768 ? "14px" : "10px" }}
            >
              {width > 768
                ? new Date(post?.createdAt).toLocaleTimeString("en", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                    timeZone: "IST",
                  })
                : new Date(post?.createdAt).toLocaleTimeString("en", {
                    year: "numeric",
                    month: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                    timeZone: "IST",
                  })}
            </Typography>
          </Box>
        }
        subheader={
          <Box className="w-full">
            <Typography
              variant="body3"
              color="text.secondary"
              sx={{
                fontSize: width > 768 ? "18px" : "13px",
                fontWeight: "bold",
              }}
            >
              {post?.clusterName && "posted in "}
              <span
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => redirectToClusterPage(post?.clusterName)}
              >
                {post?.clusterName && post.clusterName}
              </span>
            </Typography>
          </Box>
        }
      />
      <hr />
      <CardContent>
        <Typography variant="body3" className="whitespace-pre-wrap">
          {/* {post?.content && (
            <ReactLinkify>{post.content}</ReactLinkify>
          )} */}
          {post?.content && (
            <ReactLinkify
              componentDecorator={(href, text, key) => (
                <a
                  className="YourLinkClassName"
                  href={href}
                  key={key}
                  target="_blank"
                >
                  {text}
                </a>
              )}
            >
              {post.content}
            </ReactLinkify>
          )}
        </Typography>
      </CardContent>
      {post?.postImageUrl && (
        <CardMedia
          component="img"
          height="200px"
          image={post?.postImageUrl ? post.postImageUrl : "no image"}
          alt="not available"
          className="px-7 py-4"
        />
      )}
      <hr />
      <CardActions
        sx={{
          display: "flex",
          justifyContent: "space-around",
          borderRadius: "10px",
          marginBottom: "-10px",
        }}
      >
        <LikesCount
          post={post}
          baseUrl={baseUrl}
          token={token}
          width={width}
          forceUpdate={forceUpdate}
        />
        <IconButton
          className="flex flex-col-reverse gap-1 mt-3"
          aria-label="replies"
          title="reply"
          onClick={() => setCommentopen(!commentOpen)}
        >
          <span className="lg:text-xs md:text-xs text-black text-[8px] -mb-3">
            Reply
          </span>
          <img
            onClick={handleReply}
            src={Commentlogo}
            alt=""
            style={{
              height: width > 768 ? "30px" : "19px",
              width: width > 768 ? "30px" : "19px",
            }}
          />
        </IconButton>

        <IconButton aria-label="share" title="share">
          {" "}
          <ShareIcon
            sx={{
              height: width > 768 ? "30px" : "19px",
              width: width > 768 ? "30px" : "19px",
            }}
          />{" "}
        </IconButton>
      </CardActions>

      {/* reply post start */}
      {token && (
        <ReplyPost
          baseUrl={baseUrl}
          token={token}
          post={post}
          commentOpen={commentOpen}
          width={width}
          forceUpdate={forceUpdate}
        />
      )}
      {post?.comments?.map((comment) => {
        return (
          <div className="pl-12 pt-10">
            <div className="flex items-start gap-1">
              <img
                src={comment.userPic}
                className="h-7 w-7 rounded-full"
                alt=""
              />
              <div className="flex flex-col border bg-gray-100 px-2">
                <span className="text-base font-bold">{comment.userName} </span>
                <span className="mt-2 text-sm"> {comment.comment} </span>
              </div>
            </div>
          </div>
        );
      })}
    </Card>
  );
};
export default Cardd;
